module.exports = __webpack_public_path__ + "static/selina-4c4514b876738d1fd9a996328aedd691.png";